<template>
  <div class="wrapper">

    <side-bar type="sidebar" :sidebar-links="$sidebar.sidebarLinks">
      <user-menu v-on:logout="confirmAndLogout"></user-menu>
    </side-bar>

    <div class="main-panel">
      <top-navbar v-on:logout="confirmAndLogout"></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      UserMenu,
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },

      confirmAndLogout() {
        this.$sidebar.displaySidebar(false)
        this.$dialog.confirm(this.$t(`Logout`), this.$t('Are you sure to logout?'), this.$t(`Logout`))
          .then(this.$auth.logout)
      }
    }
  }

</script>
